<template>
  <figure class="pie-chart"></figure>
</template>

<script>
export default {
  name: "HomeFinancesChart",
};
</script>
